import React from 'react';

const Header = (props) => {
    return (
        <div style={{ fontSize: '2rem' }}>PTT文章收藏轉寄</div>
    )
}

export default Header;